import Vue from "vue";
import EventBus from "@/lib/utilities/eventBus";

function initialState() {
  return {
    NewProcessModal: {
      ShowModal: false,
      CallInProgress: false,
      InfoNote: null,
      EntityId: null,
      ContactId: null,
      PlatformId: null
    },
    SendEmailModal: {
      ShowModal: false,
      ContactId: null,
      IsReply: false,
      NoteId: null,
      EntityId: null
    },
    SendTextModal: {
      ShowModal: false,
      ContactId: null,
    },
    EmailConversationHistoryModal: {
      ShowModal: false,
      ConversationId: null
    },
    ContactTemplates: {
      WorkflowTemplates: [],
      Top5Recent: []
    },
    LogCallModal: {
      ShowModal: false,
      ContactId: null,
    },
    LogNoteModal: {
      ShowModal: false,
      ContactId: null,
    },
    PushToCrmModal: {
      ShowModal: false,
      ContactId: null,
      ContactName: null,
      PlatformId: null
    }
  };
}

const state = initialState();

const getters = {
  LogNoteModal: (state) => state.LogNoteModal,
  LogCallModal: (state) => state.LogCallModal,
  SendTextModal: (state) => state.SendTextModal,
  PushToCrmModal: (state) => state.PushToCrmModal,
  SendEmailModal(state) {
    return state.SendEmailModal;
  },
  EmailConversationHistoryModal(state) {
    return state.EmailConversationHistoryModal;
  }
};

const actions = {
  getDashboardCounts(context, filter) {
    return new Promise((resolve, reject) => {
      Vue.http
        .post("/pando/workflow/dashboardCounts", filter)
        .then(function(response) {
          if (response.data.Success) {
            resolve(response.data.Data);
          } else reject(response);
        })
        .catch(function(error) {
          reject(error);
        });
    });
  },
  getProcessesMonitoringData(context, request) {
    return new Promise((resolve, reject) => {
      Vue.http
        .post("/pando/workflow/processDashboard", request)
        .then(function(response) {
          if (response.data.Success) {
            resolve(response.data);
          } else reject(response);
        })
        .catch(function(error) {
          reject(error);
        });
    });
  },
  openNewProcessModal(context, data) {
    return new Promise((resolve, reject) => {
      Vue.http
        .get("/pando/workflowtemplate/startlistcustomer")
        .then(function(response) {
          if (response.data.Data && response.data.Success) {
            context.commit("openNewProcessModal", {
              Response: response.data.Data,
              User: context.getters.User,
              ContactId: data.ContactId,
              PlatformId: data.PlatformId
            });
            resolve(response.data.Data);
          } else reject(response);
        })
        .catch(function(response) {
          reject(response);
        });
    });
  },
  openSendEmailModal(context, data) {
    context.commit("openSendEmailModal", data);
  },
  closeSendEmailModal(context) {
    context.commit("closeSendEmailModal");
  },
  openEmailConversationHistoryModal(context, data) {
    context.commit("openEmailConversationHistoryModal", data);
  },
  closeNewProcessModal(context) {
    context.commit("closeNewProcessModal");
  },
  closeEmailConversationHistoryModal(context) {
    context.commit("closeEmailConversationHistoryModal");
  },
  startNewProcess(context, val) {
    return new Promise((resolve, reject) => {
      let templateId = val.TemplateId;
      let platformId = val.PlatformId;

      let requestPayload = {
        Title: val.Title,
        Form: val.Form
      };

      if (
        state.NewProcessModal.EntityId &&
        state.NewProcessModal.EntityId != "no-vehicle"
      )
        requestPayload.EntityId = state.NewProcessModal.EntityId;
      else requestPayload.ContactId = state.NewProcessModal.ContactId;
      // else if (state.NewProcessModal.CustomerId > 0)
      //   requestPayload.CustomerId = state.NewProcessModal.CustomerId;

      context.commit("toggleNewProcessCallInProgress", true);

      Vue.http
        .post(
          `/pando/workflowtemplate/starttemplate/${templateId}/${platformId}`,
          requestPayload
        )
        .then(function(response) {
          context.commit("toggleNewProcessCallInProgress", false);
          if (
            response.data.Success &&
            response.data.Data &&
            response.data.Data.Outcome == 0
          ) {
            EventBus.$emit("NEW_PROCESS_STARTED", null);
            resolve(true);
          } else reject(false);
        })
        .catch(function(response) {
          context.commit("toggleNewProcessCallInProgress", false);
          reject(false);
        });
    });
  },
  updateEntityIdForNewProcess(context, entityId) {
    context.commit("updateEntityIdForNewProcess", entityId);
  },
  openSendTextModal(context, data) {
    context.commit("handleSendTextModal", data);
  },
  closeSendTextModal(context) {
    context.commit("handleSendTextModal", null);
  },
  openLogCallModal(context, data) {
    context.commit("handleLogCallModal", data);
  },
  closeLogCallModal(context) {
    context.commit("handleLogCallModal", null);
  },
  openLogNoteModal(context, data) {
    context.commit("handleLogNoteModal", data);
  },
  closeLogNoteModal(context) {
    context.commit("handleLogNoteModal", null);
  },
  openPushToCrmModal(context, data) {
    context.commit("openPushToCrmModal", data);
  },
  closePushToCrmModal(context) {
    context.commit("closePushToCrmModal");
  },
};

const mutations = {
  openNewProcessModal(state, data) {
    let response = data.Response;
    let user = data.User;

    // Contact templates
    state.ContactTemplates.WorkflowTemplates = response.WorkflowTemplates || [];
    state.ContactTemplates.Top5Recent = response.Top5Recent || [];

    // New process  modal
    state.NewProcessModal.ContactId = data.ContactId;
    state.NewProcessModal.PlatformId = data.PlatformId;
    state.NewProcessModal.ShowModal = true;
  },
  handleLogCallModal(state, data) {
    if (data) {
      state.LogCallModal.ShowModal = true;
      state.LogCallModal.ContactId = data.ContactId;
    } else {
      state.LogCallModal.ShowModal = false;
      state.LogCallModal.ContactId = null;
    }
  },
  openPushToCrmModal(state, data) {
    state.PushToCrmModal.ContactId = data.ContactId;
    state.PushToCrmModal.ContactName = data.ContactName;
    state.PushToCrmModal.PlatformId = data.PlatformId;
    state.PushToCrmModal.ShowModal = true;
  },
  closePushToCrmModal(state) {
    state.PushToCrmModal.ShowModal = false;
    state.PushToCrmModal.ContactId = null;
    state.PushToCrmModal.ContactName = null;
    state.PushToCrmModal.PlatformId = null;
  },
  handleLogNoteModal(state, data) {
    if (data) {
      state.LogNoteModal.ShowModal = true;
      state.LogNoteModal.ContactId = data.ContactId;
    } else {
      state.LogNoteModal.ShowModal = false;
      state.LogNoteModal.ContactId = null;
    }
  },
  handleSendTextModal(state, data) {
    if (data) {
      state.SendTextModal.ContactId = data.contactId;
      state.SendTextModal.ShowModal = true;
    } else {
      state.SendTextModal.ShowModal = false;
      state.SendTextModal.ContactId = null;
    }
  },
  openSendEmailModal(state, data) {
    state.SendEmailModal.ContactId = data.ContactId;
    state.SendEmailModal.IsReply = data.IsReply;
    state.SendEmailModal.NoteId = data.NoteId;
    state.SendEmailModal.ShowModal = true;
    state.SendEmailModal.EntityId = data.EntityId;
  },
  closeSendEmailModal(state) {
    state.SendEmailModal.IsReply = false;
    state.SendEmailModal.NoteId = null;
    state.SendEmailModal.EntityId = null;
    state.SendEmailModal.ShowModal = false;
    state.SendEmailModal.ContactId = null;
  },
  openEmailConversationHistoryModal(state, data) {
    state.EmailConversationHistoryModal.ShowModal = data.ShowModal;
    state.EmailConversationHistoryModal.ConversationId = data.ConversationId;
  },
  closeNewProcessModal(state) {
    state.NewProcessModal.ShowModal = false;
    state.NewProcessModal.CallInProgress = false;
    state.NewProcessModal.InfoNote = null;
    state.NewProcessModal.EntityId = null;
    state.NewProcessModal.ContactId = null;
    state.NewProcessModal.PlatformId = null;
  },
  closeEmailConversationHistoryModal(state) {
    state.EmailConversationHistoryModal.ShowModal = false;
  },
  toggleNewProcessCallInProgress(state, value) {
    state.NewProcessModal.CallInProgress = value;
  },
  updateEntityIdForNewProcess(state, entityId) {
    state.NewProcessModal.EntityId = entityId;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/customerdashboard/Resolution.js